<template>
  <div id="app" class="container-fluid">
    <Container />
  </div>
</template>

<script>
import Container from "./components/Container.vue";
export default {
  name: "app",
  components: {
    Container
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: white;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
}
</style>
